import { Dispatcher } from 'flux';

export default new Dispatcher();



// WEBPACK FOOTER //
// ./client/core/Dispatcher.js